<template>
    <div class="row">
        <div class="col-xl-6 offset-xl-3">
            <h3 class="">How many classes would you like to create?</h3>
            <label for="classesAmount">Amount of classes</label>
            <base-input type="number" id="classesAmount" name="classesAmount"
                   v-model="model.classesAmount"
                   v-validate="modelValidations.classesAmount"
                        data-vv-as="amount of classes"
                   :error="getError('classesAmount')" />
        </div>
    </div>
</template>
<script>

    export default {
        components: {
        },
        data() {
            return {
                model: {
                    classesAmount: 1
                },
                modelValidations: {
                    classesAmount: {
                        required: true,
                        numeric: true,
                        min_value: 1,
                        max_value: 90,
                    },
                },
            };
        },
        methods: {
            getError(fieldName) {
                return this.errors.first(fieldName);
            },
            validate() {
                return this.$validator.validateAll().then(res => {
                    console.log('test');
                    this.$emit('on-validated', res, this.model);
                    return res;
                });
            }
        }
    };
</script>
<style></style>
